module.exports = __webpack_public_path__ + "img/MA-HMI-list-7.22a9782b.png";